import { Box, Button, Grid } from '@mui/material'
import Inscricao from 'entity/Inscricao'
import ReunioesParticipanteReport from 'entity/Inscricao/Relatorios/ReunioesParticipanteReport'
import Reuniao from 'entity/Reuniao'
import CatalogoReport from 'entity/Rodada/Relatorios/CatalogoReport'
import CatalogoReportES from 'entity/Rodada/Relatorios/CatalogoReportES'
import React from 'react'


export default function AcoesDoInscrito({ rodada, inscrito }) {

    const selectedOption = 'pt'
    let podeTiraCatalogo = false
    let podeTiraAgenda = false

    const { habilitaRelCatalogo, habilitaRelAgenda } = rodada?.painelInscrito || {};
    podeTiraAgenda = habilitaRelAgenda === "SIM";
    podeTiraCatalogo = habilitaRelCatalogo === "SIM";
    if (podeTiraCatalogo) {

        if (inscrito.statusEvento === "SAIU" || inscrito.statusEvento === "PRESENTE") {
            podeTiraCatalogo = true;
        } else {

            podeTiraCatalogo = false;
        }
    }



    const tirarCatalogo = () => {
        console.log('tirarCatalogo')
        Inscricao.collection.where("rodada.uid", "==", rodada.uid).where("statusEvento", "in", ["SAIU", "PRESENTE"]).get()
            .then(querySnapshot => {

                let inscricoes = querySnapshot.docs.map((doc) => doc.data());
                if (selectedOption === 'pt') {
                    new CatalogoReport({ rodada: rodada, inscritos: inscricoes }).generate()
                } else if (selectedOption === 'es') {
                    new CatalogoReportES({ rodada: rodada, inscritos: inscricoes }).generate()
                }
            })
    }

    const imprimirAgenda = () => {
        if (inscrito.termo && inscrito.status !== "PENDENTE/INSCRICAO") {

            Reuniao.collection.where("rodada.uid", "==", rodada.uid).where("status", "==", 'ATIVO').get()
                .then(querySnapshot => {
                    let reunioes = querySnapshot.docs.map((doc) => doc.data());
                    console.log('inscrito', inscrito)
                    console.log('reunioes', reunioes)
                    let reunioesP = reunioes
                        .filter((r) => r.inscricao1.uid === inscrito.uid)
                        .concat(reunioes.filter((r) => r.inscricao2.uid === inscrito.uid));

                    new ReunioesParticipanteReport({ participante: inscrito, reunioes: reunioesP }).generate({
                        textoCabecalho1: rodada.nome, // "textoCabecalho1",
                        textoCabecalho2: rodada.descricao, // "textoCabecalho2",
                    });
                })



        }
    }
    return (
        <Box mt={4}>
            <Grid container spacing={2}>
                {podeTiraCatalogo &&
                    <Grid item xs={12} md={6}>
                        <Button variant="contained" onClick={tirarCatalogo} fullWidth>Imprimir Catalogo</Button>
                    </Grid>
                }
                {podeTiraAgenda &&
                    <Grid item xs={12} md={6}>
                        <Button variant="contained" onClick={imprimirAgenda} fullWidth>Imprimir Agenda</Button>
                    </Grid>
                }

            </Grid>


        </Box>
    )
}
